export const FETCH_TRIPMASTER_REQUEST = "FETCH_TRIPMASTER_REQUEST";
export const FETCH_TRIPMASTER_SUCCESS = "FETCH_TRIPMASTER_SUCCESS";
export const FETCH_TRIPMASTER_FAILURE = "FETCH_TRIPMASTER_FAILURE";

export const SAVE_TRIPMASTER_REQUEST = "SAVE_TRIPMASTER_REQUEST";
export const SAVE_TRIPMASTER_SUCCESS = "SAVE_TRIPMASTER_SUCCESS";
export const SAVE_TRIPMASTER_FAILURE = "SAVE_TRIPMASTER_FAILURE";

export const DELETE_TRIPMASTER_REQUEST = "DELETE_TRIPMASTER_REQUEST";
export const DELETE_TRIPMASTER_SUCCESS = "DELETE_TRIPMASTER_SUCCESS";
export const DELETE_TRIPMASTER_FAILURE = "DELETE_TRIPMASTER_FAILURE";
